/** Why the API rejected a sign-in (`LoginErrorCode` in api/v1/auth/serializers.py). */
export type LoginErrorCode =
  | 'account_locked'
  | 'wrong_credentials'
  | 'account_disabled'
  | 'no_company_access'
  | 'forced_sso';

export type LoginErrorBody = {
  nonFieldErrors?: string[];
  email?: string[];
  password?: string[];
  code?: LoginErrorCode;
};

export type LoginErrors = {
  email?: string;
  password?: string;
  code?: LoginErrorCode;
};

export const getLoginErrors = (
  body: LoginErrorBody | undefined,
  unknownError: string,
): LoginErrors => {
  if (body?.nonFieldErrors) {
    return {
      password: body.nonFieldErrors.join(', '),
      ...(body.code && { code: body.code }),
    };
  }
  if (body?.email || body?.password) {
    return {
      email: body.email ? body.email.join(', ') : undefined,
      password: body.password ? body.password.join(', ') : undefined,
    };
  }
  return { password: unknownError };
};
